var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showSnackbar
        ? _c("Snackbar", {
            attrs: {
              snackbarColor: _vm.snackbarColor,
              snackbarMessage: _vm.snackbarMessage
            },
            on: {
              close: function($event) {
                return _vm.closeSnackbar()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _c(
            "v-card",
            { staticClass: "settings_panel_card", attrs: { flat: "" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "settings_toolbar",
                  attrs: { flat: "", dense: "" }
                },
                [
                  _c(
                    "v-toolbar-title",
                    { staticClass: "settings_panel_heading" },
                    [_vm._v("Configuration")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _vm.editableButton && _vm.showEmptyConfigurationMessage
                    ? _c(
                        "v-btn",
                        { attrs: { depressed: "", icon: "", small: "" } },
                        [
                          _c(
                            "v-icon",
                            {
                              class: _vm.editConfigStatus
                                ? "enable"
                                : "disabled",
                              on: {
                                click: function($event) {
                                  return _vm.editConfiguration()
                                }
                              }
                            },
                            [_vm._v("create")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.importedFileName && _vm.isSuperAdmin
                    ? _c(
                        "span",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mx-2",
                              attrs: { depressed: "", icon: "", small: "" }
                            },
                            [
                              _c(
                                "label",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mx-2",
                                      attrs: { flat: "", title: "Import" }
                                    },
                                    [_vm._v("system_update_alt")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "input",
                                    _vm._b(
                                      {
                                        ref: "file",
                                        attrs: {
                                          type: "file",
                                          id: "file",
                                          accept: "application/json",
                                          onclick: "this.value=null;"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.handleFileUpload()
                                          }
                                        }
                                      },
                                      "input",
                                      _vm.handleFile,
                                      false
                                    )
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: { depressed: "", icon: "", small: "" },
                              on: {
                                click: function($event) {
                                  return _vm.exportAppConfigurationFile()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mx-2",
                                  attrs: { flat: "", title: "Export" }
                                },
                                [_vm._v("open_in_browser")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isSuperAdmin
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "#736B63",
                            dark: "",
                            small: "",
                            depressed: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.openPopUPLinkIsClicked("advance")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    advance editor\n                "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "apps_config_div" },
                [
                  _c(
                    "v-layout",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showEmptyConfigurationMessage,
                          expression: "showEmptyConfigurationMessage"
                        }
                      ],
                      attrs: { wrap: "" }
                    },
                    [
                      _c(
                        "v-flex",
                        {
                          staticClass: "ml-4 my-3 grey--text",
                          attrs: { xs2: "" }
                        },
                        [_c("b", [_vm._v("URL")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "ml-4 my-3", attrs: { xs8: "" } },
                        [
                          _vm.isEditable
                            ? _c("span", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.editableCongiguration.url,
                                      expression: "editableCongiguration.url"
                                    }
                                  ],
                                  staticClass: "editableInput",
                                  class:
                                    _vm.validateURLStatus == null
                                      ? ""
                                      : _vm.validateURLStatus
                                      ? "enable"
                                      : "disable",
                                  attrs: { type: "url" },
                                  domProps: {
                                    value: _vm.editableCongiguration.url
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.editableCongiguration,
                                        "url",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            : _c("span", [
                                _c("span", { staticClass: "configURL" }, [
                                  _vm._v(
                                    _vm._s(_vm.tablesConfiguration.callback)
                                  )
                                ])
                              ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "ml-4 my-3 grey--text",
                          attrs: { xs2: "" }
                        },
                        [_c("b", [_vm._v("Callback Header")])]
                      ),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs9: "" } }, [
                        _c("div", { staticClass: "apps_config_table_div" }, [
                          _c(
                            "table",
                            { staticClass: "apps_config_component_table" },
                            [
                              _c("thead", [
                                _vm.tablesConfiguration.headers != ""
                                  ? _c("tr", [
                                      _c("th", [_vm._v("Key")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Value")]),
                                      _vm._v(" "),
                                      _vm.isEditable
                                        ? _c("th", [_vm._v("Actions")])
                                        : _vm._e()
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                [
                                  _vm._l(
                                    _vm.tablesConfiguration.headers,
                                    function(key, value, index) {
                                      return _c("tr", { key: key }, [
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { color: "purple" } },
                                              [_vm._v("vpn_key")]
                                            ),
                                            _vm._v(
                                              " \n                                            " +
                                                _vm._s(value) +
                                                "\n                                        "
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(key) +
                                              "\n                                        "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.isEditable
                                          ? _c("td", [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "material-icons deleteHeader",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.deleteHeader(
                                                        index,
                                                        key,
                                                        value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("delete")]
                                              )
                                            ])
                                          : _vm._e()
                                      ])
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.isEditable
                                    ? _c("tr", [
                                        _c("td", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.callbackHeaderValue,
                                                expression:
                                                  "callbackHeaderValue"
                                              }
                                            ],
                                            staticClass: "inputcallbackheader",
                                            attrs: {
                                              type: "text",
                                              title: "key required",
                                              required: "",
                                              placeholder: "key"
                                            },
                                            domProps: {
                                              value: _vm.callbackHeaderValue
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.callbackHeaderValue =
                                                  $event.target.value
                                              }
                                            }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.callbackHeaderName,
                                                expression: "callbackHeaderName"
                                              }
                                            ],
                                            staticClass: "inputcallbackheader",
                                            attrs: {
                                              type: "text",
                                              title: "Value required",
                                              required: "",
                                              placeholder: "value"
                                            },
                                            domProps: {
                                              value: _vm.callbackHeaderName
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.callbackHeaderName =
                                                  $event.target.value
                                              }
                                            }
                                          })
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: {
                                                  row: "",
                                                  wrap: "",
                                                  id: "callbackHeaderActions"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass: "mt-2",
                                                    attrs: { xs3: "" }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        class:
                                                          _vm.callbackHeaderValid &&
                                                          _vm.callbackHeaderNameValid
                                                            ? "enable"
                                                            : "disabled",
                                                        attrs: {
                                                          color: "green",
                                                          title: "add"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.saveCallbackHeader()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "check_circle_outline"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass: "mt-2",
                                                    attrs: { xs3: "" }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "red",
                                                          title: "clear content"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.closeCallbackHeader()
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("highlight_off")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "ml-4 my-4 grey--text",
                          attrs: { xs2: "" }
                        },
                        [_c("b", [_vm._v("Certificate")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "ml-4 my-4", attrs: { xs8: "" } },
                        [
                          _vm.isEditable
                            ? _c("span", [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.editableCongiguration.certificate,
                                      expression:
                                        "editableCongiguration.certificate"
                                    }
                                  ],
                                  staticClass: "certificateConfiguration",
                                  domProps: {
                                    value: _vm.editableCongiguration.certificate
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.editableCongiguration,
                                        "certificate",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            : _c("span", [
                                _c(
                                  "pre",
                                  { staticClass: "certificateInConfiguration" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.tablesConfiguration.certificate
                                      )
                                    )
                                  ]
                                )
                              ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.showEmptyConfigurationMessage,
                          expression: "!showEmptyConfigurationMessage"
                        }
                      ]
                    },
                    [
                      _c("span", { staticClass: "empty_configuration_style" }, [
                        _vm._v(
                          "No Configuration Options Available For This Type Of Token"
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.isEditable
                ? _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-4 mb-4",
                          attrs: {
                            color: "#736B63",
                            dark: "",
                            small: "",
                            depressed: "",
                            id: "configurationSaveBtn"
                          },
                          on: {
                            click: function($event) {
                              return _vm.saveEditedChanges("notification")
                            }
                          }
                        },
                        [_vm._v("save")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-4 mb-4",
                          attrs: {
                            color: "#736B63",
                            dark: "",
                            small: "",
                            depressed: "",
                            id: "cancelEditedConfigurationBtn"
                          },
                          on: {
                            click: function($event) {
                              return _vm.cancelEditedConfiguration()
                            }
                          }
                        },
                        [_vm._v("cancel")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c(
                    "v-dialog",
                    {
                      attrs: {
                        "max-width": "500",
                        scrollable: "",
                        persistent: ""
                      },
                      model: {
                        value: _vm.updateConfigurationFile,
                        callback: function($$v) {
                          _vm.updateConfigurationFile = $$v
                        },
                        expression: "updateConfigurationFile"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "import-config-popup",
                          attrs: { id: "importPopup" }
                        },
                        [
                          _c(
                            "v-card-title",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c("v-flex", { attrs: { xs12: "" } }, [
                                    _c(
                                      "span",
                                      { staticClass: "headline indigo--text" },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { medium: "" } },
                                          [_vm._v("info_outline")]
                                        ),
                                        _vm._v(
                                          " Import File\n                                        "
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _vm.newAppType
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "checkbox_icon",
                                              on: {
                                                click: function($event) {
                                                  _vm.appChange = !_vm.appChange
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.appChange
                                                      ? "check_box"
                                                      : "check_box_outline_blank"
                                                  )
                                                )
                                              ]),
                                              _vm._v(
                                                "\n                                            Update Token Type to " +
                                                  _vm._s(_vm.newAppType) +
                                                  "\n                                        "
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("br"),
                                      _c("br"),
                                      _vm._v(" "),
                                      _vm.servicesList.length > 0
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "checkbox_icon",
                                              on: {
                                                click: function($event) {
                                                  _vm.servicesChange = !_vm.servicesChange
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.servicesChange
                                                      ? "check_box"
                                                      : "check_box_outline_blank"
                                                  )
                                                )
                                              ]),
                                              _vm._v(
                                                "\n                                            Remove services not present in the new configuration\n                                        "
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _vm._l(_vm.servicesList, function(
                                        services
                                      ) {
                                        return _c("span", { key: services }, [
                                          _vm._v("      *" + _vm._s(services)),
                                          _c("br")
                                        ])
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    depressed: "",
                                    color: "grey lighten-3",
                                    id: "cancelImportBtn"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.updateConfigurationFile = false
                                    }
                                  }
                                },
                                [_vm._v("cancel")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    depressed: "",
                                    color: "grey lighten-3",
                                    title: "save",
                                    id: "importBtn"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.importAppConfigurationFile(),
                                        (_vm.updateConfigurationFile = false)
                                    }
                                  }
                                },
                                [_vm._v("Import")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showConfig,
                        expression: "showConfig"
                      }
                    ],
                    staticClass: "show-info-background"
                  }),
                  _vm._v(" "),
                  _c(
                    "v-dialog",
                    {
                      staticClass: "show-info-popup show-info-popup-config",
                      attrs: { width: "80%", persistent: "" },
                      model: {
                        value: _vm.showConfig,
                        callback: function($$v) {
                          _vm.showConfig = $$v
                        },
                        expression: "showConfig"
                      }
                    },
                    [
                      _c(
                        "v-card",
                        { attrs: { height: "38rem" } },
                        [
                          _c(
                            "v-toolbar",
                            {
                              attrs: {
                                flat: "",
                                dense: "",
                                color: "indigo lighten-1",
                                dark: ""
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("build")]),
                              _vm._v(" "),
                              _c("v-toolbar-title", [
                                _vm._v(
                                  "Advanced editor - " +
                                    _vm._s(_vm.displayPanelName)
                                )
                              ]),
                              _vm._v(" \n                            "),
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "div",
                                { class: _vm.gotAPIResponse ? "" : "disabled" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            !_vm.showPanelForServicesAction &&
                                            !_vm.editInPopupConfig &&
                                            !_vm.disableEditButton,
                                          expression:
                                            "!showPanelForServicesAction && !editInPopupConfig && !disableEditButton"
                                        }
                                      ],
                                      staticClass: "mx-2",
                                      attrs: {
                                        flat: "",
                                        id: "editConfiguration",
                                        title: "Edit Configuration"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.editConfig()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    create\n                                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-icon",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showPanelForServicesAction,
                                          expression:
                                            "showPanelForServicesAction"
                                        }
                                      ],
                                      staticClass: "mx-2",
                                      attrs: {
                                        flat: "",
                                        id: "openConfigurations",
                                        title: "Configuration Settings"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.backToConfiguration()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    settings\n                                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-icon",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.showPanelForServicesAction,
                                          expression:
                                            "!showPanelForServicesAction"
                                        }
                                      ],
                                      staticClass: "mx-2",
                                      attrs: {
                                        flat: "",
                                        title: "Add service to app",
                                        id: "services"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.enableServicesForApp()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    add\n                                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mx-2",
                                      attrs: {
                                        flat: "",
                                        id: "closeAdvancedEditor",
                                        title: "Close Advanced Editor"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.closeConfig()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    clear\n                                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.showPanelForServicesAction
                            ? _c(
                                "div",
                                { staticClass: "advancedEditorBody" },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { xs1: "" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "advanced_editor_config_heading"
                                            },
                                            [_vm._v("Configuration:")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs6: "" } },
                                        [
                                          _c("v-select", {
                                            staticClass: "mt-1 ml-4",
                                            attrs: {
                                              id: "servicesDropdown",
                                              solo: "",
                                              items: _vm.availableConfig
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.openPopUPLinkIsClicked()
                                              }
                                            },
                                            model: {
                                              value: _vm.selectedServiceName,
                                              callback: function($$v) {
                                                _vm.selectedServiceName = $$v
                                              },
                                              expression: "selectedServiceName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            sm12: "",
                                            md12: "",
                                            lg12: ""
                                          }
                                        },
                                        _vm._l(
                                          _vm.listOfConfigurationKeys,
                                          function(item, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass:
                                                  "btn-group configButton"
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "buttonGroupInConfiguration",
                                                    class:
                                                      _vm.selectedIndex == index
                                                        ? "active"
                                                        : "",
                                                    attrs: {
                                                      id: "configurationTypes"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.showConfigurationOfItem(
                                                          item,
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(item))]
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            sm12: "",
                                            md12: "",
                                            lg12: ""
                                          }
                                        },
                                        [
                                          _vm.editInPopupConfig
                                            ? _c("span", [
                                                _vm.editInPopupConfig
                                                  ? _c("textarea", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm
                                                              .editConfigInPopupTrue
                                                              .edited,
                                                          expression:
                                                            "editConfigInPopupTrue.edited"
                                                        }
                                                      ],
                                                      staticClass: "text_area",
                                                      attrs: {
                                                        id: "configurationInfo"
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm
                                                            .editConfigInPopupTrue
                                                            .edited
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm.editConfigInPopupTrue,
                                                            "edited",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ])
                                            : _c("span", [
                                                _c(
                                                  "pre",
                                                  { staticClass: "text_area" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.configResponse)
                                                    )
                                                  ]
                                                )
                                              ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showPanelForServicesAction
                            ? _c(
                                "div",
                                { staticClass: "service_panel_body" },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "service_panel_layout",
                                      attrs: { row: "", wrap: "" }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "mt-3 mr-1",
                                          attrs: {
                                            xs12: "",
                                            sm12: "",
                                            md12: "",
                                            lg12: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              class: _vm.showFailedListOfServices
                                                ? "servicelist_config_body_panel_2"
                                                : "servicelist_config_body"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "totalappsList_userpage_body"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "displayList_userpage_heading"
                                                    },
                                                    [_vm._v("List of Services")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      class: _vm.showFailedListOfServices
                                                        ? "servicelist_minimized_class"
                                                        : "servicesListselecttag",
                                                      attrs: {
                                                        size: "30",
                                                        id: "totalList"
                                                      }
                                                    },
                                                    _vm._l(
                                                      _vm.notEnabledServices,
                                                      function(item1) {
                                                        return _c(
                                                          "option",
                                                          { key: item1.id },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item1)
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "buttonsappslist_userpage_body"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "shifticonsforList_userpage",
                                                      class: _vm.gotAPIResponse
                                                        ? ""
                                                        : "disabled"
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                          attrs: {
                                                            id: "enableService"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.addServiceToSelectedList()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "arrow_forward"
                                                          )
                                                        ]
                                                      ),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                          attrs: {
                                                            id: "disableService"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeServiceFromSelectedList()
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("arrow_back")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectedAppsList_userpage_body"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "displayList_userpage_heading"
                                                    },
                                                    [_vm._v("Enabled services")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      class: _vm.showFailedListOfServices
                                                        ? "servicelist_minimized_class"
                                                        : "servicesListselecttag",
                                                      attrs: {
                                                        size: "30",
                                                        id: "selectedList"
                                                      }
                                                    },
                                                    _vm._l(
                                                      _vm.enabledServices,
                                                      function(item2) {
                                                        return _c(
                                                          "option",
                                                          { key: item2.id },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item2)
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.showFailurePanel
                                        ? _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: "",
                                                lg12: ""
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "failed_services",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showFailedList()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Failed to enable/disable services"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("i", {
                                                    staticClass:
                                                      "material-icons failure_droparrow",
                                                    class: _vm.showFailedListOfServices
                                                      ? "minimizefailedclass"
                                                      : "maximizefailedclass",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.showFailedListOfServices
                                                          ? "keyboard_arrow_down"
                                                          : "keyboard_arrow_up"
                                                      )
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.showFailedListOfServices
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "service_panel_body"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          class: _vm.showFailedListOfServices
                                                            ? "servicelist_config_body_panel_2"
                                                            : "servicelist_config_body"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "totalappsList_userpage_body"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "displayList_userpage_heading"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "List of Failed Services"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "select",
                                                                {
                                                                  staticClass:
                                                                    "servicesListselecttag",
                                                                  class: _vm.showFailedListOfServices
                                                                    ? "servicelist_minimized_class"
                                                                    : "servicesListselecttag",
                                                                  attrs: {
                                                                    size: "30",
                                                                    id:
                                                                      "totalFailedList"
                                                                  }
                                                                },
                                                                _vm._l(
                                                                  _vm.failureList1,
                                                                  function(
                                                                    item1
                                                                  ) {
                                                                    return _c(
                                                                      "option",
                                                                      {
                                                                        key:
                                                                          item1.id
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item1
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (!_vm.showPanelForServicesAction &&
                                      _vm.editInPopupConfig) ||
                                    _vm.showPanelForServicesAction,
                                  expression:
                                    "(!showPanelForServicesAction && editInPopupConfig) || showPanelForServicesAction"
                                }
                              ],
                              class: _vm.gotAPIResponse ? "" : "disabled"
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  class: _vm.disableSaveButton
                                    ? "disabled"
                                    : "",
                                  attrs: {
                                    small: "",
                                    dark: "",
                                    color: "deep-purple darken-3",
                                    id: "saveBtn"
                                  },
                                  on: {
                                    click: function($event) {
                                      !_vm.showPanelForServicesAction &&
                                      _vm.editInPopupConfig
                                        ? _vm.saveEditedChanges("other")
                                        : _vm.saveSelectedServicesList("save")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                Save\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    dark: "",
                                    color: "deep-purple darken-3",
                                    id: "cancelBtn"
                                  },
                                  on: {
                                    click: function($event) {
                                      !_vm.showPanelForServicesAction &&
                                      _vm.editInPopupConfig
                                        ? _vm.cancelPOPupEdit()
                                        : _vm.saveSelectedServicesList("cancel")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                Cancel\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showErrorMessage,
                                      expression: "showErrorMessage"
                                    }
                                  ],
                                  staticClass: "error_message"
                                },
                                [_vm._v(_vm._s(_vm.errorMessage) + " ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.importFile
        ? _c("confirmationPopupVue", {
            attrs: {
              confirmationTitle: "Import File",
              confirmationText: "import file",
              name: _vm.showSelectedFile
            },
            on: {
              action: function($event) {
                return _vm.checkDifferentApptypes()
              },
              close: function($event) {
                return _vm.cancelFileUpload()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }